import React, { useState, useContext, useEffect } from "react";
import MainTitle from "components/MainTitle";
import FormContainer from "components/FormContainer";
import Fieldset from "components/Fieldset";
import Legend from "components/Legend";
import InputControl from "components/InputControl";
import FormActions from "components/FormActions";
import { Button } from "mondrian-react";
import { SendToken } from "core/api/changeEmail/changeEmailApi";
import Analytics from "core/Utils/Analytics";
import { store } from "../../store.js";
import Modal from "components/Modal";
import Input from "components/Input/Input.js";
import { isValidEmail } from "core/Utils/Utils.js";
import blacklist from "../../blacklist/emails-temporarios.json";
import { isProd } from "core/Utils/Utils.js";
const ChangeEmail = ({ setForm, formData, navigation, setIsLoading }) => {
  const { next } = navigation;
  const logoutLink = process.env.REACT_APP_PING_AUTHORIZE;
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState("");
  const [confirmEmailError, setConfirmEmailError] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const userEmail = state.emailData?.email;
  let componentTitle = userEmail ? "Alterar e-mail" : "Cadastrar e-mail";
  const { accesstoken = "undefined" } = state;

  useEffect(
    function () {
      Analytics().setVirtualPageView();
      dispatch({
        type: "SET_GA",
        payload: { currentFlow: "alterar-senha" },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(
    function () {
      let hasError = emailError || confirmEmailError;
      let isDirty = email || confirmEmail;
      if (!isDirty || hasError) {
        setEmailValid(false);
      } else {
        setEmailValid(true);
      }
    },
    [email, confirmEmail, emailError, confirmEmailError]
  );

  async function handleSubmit(e) {
    e.preventDefault();
    dispatch({
      type: "SET_EMAIL_DATA",
      payload: { changeEmail: email },
    });
    setIsLoading(true);

    const submitData = { newEmail: email };
    const sendTokenResponse = await SendToken(submitData, accesstoken);
    const { code = 0, error = null, warning = null, data = '' } = sendTokenResponse;

    setIsLoading(false);

    dispatch({
      type: "SET_USER_DATA",
      payload: { currentUserData: data?.userData },
    });

    if (warning) {
      setEmailError(warning.message);
      Analytics().setErrorEvent({
        eventAction: "callback:alterar-email",
        eventLabel: warning.message,
        code: warning?.errorCode
      });
      return null;
    }

    if (error != null) {
      const { message } = error?.warning;
      
      setModalContent(error);
      Analytics().setErrorEvent({
        eventAction: "callback:alterar-email",
        eventLabel: message,
        code: error?.errorCode,
      });

      if (code === 401) {
        setTimeout(function () {
          window.location.href = logoutLink;
        }, 2000);
      }
    } else {
      Analytics().setEvent({
        eventAction: "callback:alterar-email",
        eventLabel: "tentativa:sucesso",
      });

      dispatch({
        type: "SET_EMAIL_DATA",
        payload: { changeEmail: email, emailSessionId: data?.sessionId },
      });

      next();
    }
  }

  function changeEmail(e) {
    const userEmail = e.target.value;
    setEmail(userEmail);

    const domain = userEmail.split("@")[1];
    if (blacklist.includes(domain) && isProd()) {
      setEmailError("O domínio de e-mail é inválido");
    } else if (isValidEmail(userEmail)) {
      setEmailError("");
    } else {
      setEmailError("E-mail inválido");
    }

    if (userEmail !== confirmEmail) {
      setConfirmEmailError("Os e-mails devem ser iguais");
    } else {
      setConfirmEmailError("");
    }
  }

  function changeConfirmEmail(e) {
    const emailConfirmationValue = e.target.value;
    setConfirmEmail(emailConfirmationValue);

    const domain = emailConfirmationValue.split("@")[1];
    if (blacklist.includes(domain) && isProd()) {
      setConfirmEmailError("O domínio de e-mail é inválido");
    } else if (emailConfirmationValue === email) {
      setConfirmEmailError("");
    } else {
      setConfirmEmailError("Os e-mails devem ser iguais");
    }
  }

  function onRequestClose(data = {}) {
    setModalContent(null);
  }

  return (
    <>
      {modalContent && (
        <Modal onClose={onRequestClose} content={modalContent} />
      )}
      <FormContainer onSubmit={handleSubmit}>
        <MainTitle sm tabIndex="20">
          {componentTitle}
        </MainTitle>
        <Fieldset>
          <Legend>Digite e confirme o novo e-mail de acesso</Legend>
          <InputControl>
            <Input
              tabIndex="21"
              label="E-mail"
              name="email"
              id="email"
              inputMode="email"
              autoComplete="email"
              autoCapitalize="off"
              onChange={changeEmail}
              error={emailError}
            />
          </InputControl>
          <InputControl>
            <Input
              tabIndex="22"
              label="Confirmar E-mail"
              name="confirmEmail"
              id="confirmEmail"
              inputMode="email"
              autoComplete="email"
              autoCapitalize="off"
              onChange={changeConfirmEmail}
              error={confirmEmailError}
              blockPaste={true}
            />
          </InputControl>
          <FormActions>
            <Button disabled={!emailValid} tabIndex="23">
              Continuar
            </Button>
          </FormActions>
        </Fieldset>
      </FormContainer>
    </>
  );
};

export default ChangeEmail;
